import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Globals } from 'projects/core/src/globals';
import { ModelList } from 'projects/core/src/include/modellist';
import { Filter, FilterMode, OrderingMode } from 'projects/core/src/include/structures';
import { UserService } from 'projects/core/src/lib/user.service';
import { CashRegister } from '../../../db/cashregister';
import { CashregisterService } from '../../../services/cashregister.service';
import { ShopsService } from '../../../services/shops.service';
import { CashregisterDetailComponent } from './cashregister-detail/cashregister-detail.component';
import { CashFlowDetailsComponent } from '../cash-flow-details/cash-flow-details.component';

@Component({
  selector: 'app-cashregister',
  templateUrl: './cashregister.component.html',
  styleUrls: ['./cashregister.component.css']
})
export class CashregisterComponent extends ModelList<CashRegister> implements OnInit,AfterViewInit {
  editCashes=false;
  
  @Input()
  filterbox:boolean=true;


  filter_search:Filter=new Filter();
  filter_date:Filter=new Filter();  
  filter_status:Filter=new Filter();
  filter_id_user:Filter=new Filter();
  filter_created_from:Filter=new Filter();

  filter_id_cash:Filter=new Filter();

  total_amount:number=0;
  total_paid:number=0;
  isFilterSet:boolean=false;
  shops=[];
  cashes=[];
  cashesTotal=[];
  constructor(
    private fb1: UntypedFormBuilder,
    private cashregiserService: CashregisterService,
    private userService:UserService,
    private shopsService:ShopsService,
  ) { super(cashregiserService,fb1);
    this.detailViewModal=CashregisterDetailComponent;
    this.modulename="cash-flow";
  }

  ngOnInit(): void {
    super.ngOnInit.apply(this, arguments); 
    this.title = 'Stato cassa';
    this.getCashes()
    
  
   
  }

  getCashes(force_download=false){
    this.cashregiserService.getCashes(force_download).subscribe((result)=>{
      this.cashes=result;
    })
  }

  ngAfterViewInit(): void {
    const default_address=Globals.parameters.get("general").getParam("default_address");

    this.shopsService.getItemsByAddress(default_address).subscribe((items)=>{
      this.shops=items;
    });
  }


  setFilters():void{
    this.filter_search.mode=FilterMode.like;
    this.filter_search.fields=[];
    this.filter_search.fields.push("c.description");
    this.filter_search.value="";
    this.filter.push(this.filter_search);

    this.filter_status.mode=FilterMode.normal;
    this.filter_status.fields=[];
    this.filter_status.fields.push("c.status");
    this.filter_status.value="1";
    this.filter.push(this.filter_status);

    this.filter_id_cash.mode=FilterMode.normal;
    this.filter_id_cash.fields=[];
    this.filter_id_cash.fields.push("c.id_cash");
    this.filter_id_cash.value="";
    this.filter.push(this.filter_id_cash);

    this.filter_created_from.mode=FilterMode.normal;
    this.filter_created_from.fields=[];
    this.filter_created_from.fields.push("c.created_from");
    if(!this.checkPermissions("showCreatedFrom")){
      this.filter_created_from.value="";
    }else{
      this.filter_created_from.value=this.user['shop']?this.user['shop']['id']:"";
    }
    this.filter.push(this.filter_created_from);

    this.filter_date.mode=FilterMode.date;
    this.filter_date.fields=[];
    this.filter_date.fields.push("c.date");
    this.filter.push(this.filter_date);
    
    
   

    

   
   
    
    
    
    this.filter_id_user.mode=FilterMode.normal;
    this.filter_id_user.fields=[];
    this.filter_id_user.fields.push("c.id_user");
    this.filter_id_user.value="";
    this.filter.push(this.filter_id_user);
    /*
    if(this.mode!="embedded")
      Globals.navigation.getStateFilters(this.constructor.name,this.filter);
    */

    this.ordering.mode=OrderingMode.discendent;
    this.ordering.field="c.date";
    
    if(this.mode=="embedded"){
      this.paging_count=10000000;
    }

   

    this.isFilterSet=true;
  }

  ngOnChanges():void{
      this.updateList();
  }

  getCashesTotal(){
    this.cashregiserService.getCashesTotal().subscribe((result)=>{
      this.cashesTotal=result;
    })
  }


  updateList():void{
    if(this.mode=="embedded"){ //non avviare la ricerca fino a quando non si è impostato l'id_table
        return;
    }


    if(!this.isFilterSet)
      this.setFilters();
      
    

    this.total_amount=0;
    this.total_paid=0;
    

     this.afterGetItems=(()=>{
     
      this.getCashesTotal();
      //calcolo i valori totali
      if(this.list.length>0){
        this.cashregiserService.getTotals(this.filter,this.orderingList,this.advancedFilter).subscribe((item)=>{
          this.total_paid=item.total;
        })
      }
    });

    this.getItems();
  }

  openCashflowDetail(record:any){
    Globals.modal.showModal(CashFlowDetailsComponent,[
      {"name":"mode","value":"modal"},
      {"name":"amount","value":record.amount},
      {"name":"paid","value":record.paid},
    ],()=>{

    })
  }

  deleteCash(id:any){
    Globals.modal.showConfirm("Eliminazione","Sicuro di voler eliminare la cassa?",()=>{
      this.cashregiserService.deleteCash(id).subscribe(()=>{
        this.getCashes(true);
      })
    })
    
  }


  addCash(){
    
    let name=prompt("Inserisci il nome della cassa");
    if(name){
      this.cashregiserService.addCash(name).subscribe(()=>{
        this.getCashes(true);
      })
    }
  }

}
